









import { Component, Vue, Prop } from "vue-property-decorator";
import request from "@/api/index";
import { IShareInfo } from "@/api/types";
import Native from "@/common/Native";
@Component
export default class Header extends Vue {
  @Prop()
  private newsId!: string;

  @Prop()
  private appId!: string;

  private shareInfo: IShareInfo | {} = {};

  private isShow = false;

  mounted() {
    if (Native.isOpenInApp()) {
      this.isShow = false;
    } else {
      this.isShow = true;
      const app = document.getElementById("app") as HTMLDivElement;
      app.style.height = "calc(100vh - (100vw * 0.16))";
      app.style.width = "100%";
      app.style.position = "absolute";
      app.style.top = "16vw";
      this.getShareInfo(this.appId);
    }
  }

  async getShareInfo(appId: string) {
    const res = await request.getShareInfo(appId);
    if (!res.code) {
      this.shareInfo = res.data;
    }
  }

  beforeDestroy() {
    this.close();
  }

  private close() {
    const app = document.getElementById("app") as HTMLDivElement;
    app.style.height = "100%";
    app.style.top = "";
    this.isShow = false;
  }

  openApp() {
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    const Params = {
      id: "-1",
      sourceId: "-1",
      sourceType: "-1",
      url: location.href,
      shareUrl: location.href
    };
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${Params.id}&&&sourceId=${Params.id}&&&sourceType=1&&&url=${Params.url}&&&shareUrl=${Params.shareUrl}`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      location.href =
        shareInfo.schemeUrl.replace("http://", "").replace("com/", "com") +
        "://" +
        `?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
}
